import { HelmetProvider } from "react-helmet-async"
import { Provider } from "react-redux"
import store, { persistor } from "./app/store"
import { PersistGate } from "redux-persist/integration/react"
import { RouterProvider } from "react-router-dom"
import router from "./Routes/Routes"
import { Toaster } from "react-hot-toast"
import { clearPendingEligibilityForm } from "./utils/pendingEligibilityForm"

// One-off purge of personal data left in browser storage by the old public
// eligibility funnel. Runs at module load so every visitor is cleaned up on
// their next visit, not only those who hit an expired session.
clearPendingEligibilityForm()

function App() {


  return (
    <>
      <HelmetProvider>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <RouterProvider router={router} />
          </PersistGate>
          <Toaster />
        </Provider>
      </HelmetProvider>
    </>
  )
}

export default App
